export const seoMetrics = {
  trackPageView: (language, pageType) => {
    const metrics = {
      timestamp: new Date().toISOString(),
      language: language,
      pageType: pageType,
      userAgent: navigator.userAgent,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      performance: {
        domContentLoaded: 0,
        loadComplete: 0,
        firstContentfulPaint: 0,
        largestContentfulPaint: 0
      }
    };

    if (window.performance && window.performance.timing) {
      const timing = window.performance.timing;
      metrics.performance.domContentLoaded = timing.domContentLoadedEventEnd - timing.navigationStart;
      metrics.performance.loadComplete = timing.loadEventEnd - timing.navigationStart;
    }

    if (window.performance && window.performance.getEntriesByType) {
      const paintEntries = window.performance.getEntriesByType('paint');
      if (paintEntries.length > 0) {
        metrics.performance.firstContentfulPaint = paintEntries[0].startTime;
        if (paintEntries.length > 1) {
          metrics.performance.largestContentfulPaint = paintEntries[paintEntries.length - 1].startTime;
        }
      }
    }

    console.log('[SEO Metrics]', JSON.stringify(metrics));
    return metrics;
  },

  trackLanguageSwitch: (fromLanguage, toLanguage) => {
    const metrics = {
      timestamp: new Date().toISOString(),
      event: 'language_switch',
      from: fromLanguage,
      to: toLanguage
    };
    console.log('[SEO Metrics]', JSON.stringify(metrics));
    return metrics;
  },

  trackSearchQuery: (query, language) => {
    const metrics = {
      timestamp: new Date().toISOString(),
      event: 'search_query',
      query: query,
      language: language,
      resultsCount: 0
    };
    console.log('[SEO Metrics]', JSON.stringify(metrics));
    return metrics;
  },

  generateReport: () => {
    const report = {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      language: document.documentElement.lang,
      title: document.title,
      description: document.querySelector('meta[name="description"]')?.content,
      keywords: document.querySelector('meta[name="keywords"]')?.content,
      canonical: document.querySelector('link[rel="canonical"]')?.href,
      hreflangCount: document.querySelectorAll('link[hreflang]').length,
      schemaOrgCount: document.querySelectorAll('script[type="application/ld+json"]').length,
      performance: {
        domContentLoaded: 0,
        loadComplete: 0,
        firstContentfulPaint: 0,
        largestContentfulPaint: 0
      }
    };

    if (window.performance && window.performance.timing) {
      const timing = window.performance.timing;
      report.performance.domContentLoaded = timing.domContentLoadedEventEnd - timing.navigationStart;
      report.performance.loadComplete = timing.loadEventEnd - timing.navigationStart;
    }

    if (window.performance && window.performance.getEntriesByType) {
      const paintEntries = window.performance.getEntriesByType('paint');
      if (paintEntries.length > 0) {
        report.performance.firstContentfulPaint = paintEntries[0].startTime;
        if (paintEntries.length > 1) {
          report.performance.largestContentfulPaint = paintEntries[paintEntries.length - 1].startTime;
        }
      }
    }

    return report;
  }
};

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    const language = document.documentElement.lang || 'zh-CN';
    seoMetrics.trackPageView(language, 'home');
  });
}